import omit from 'lodash/omit';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectFeatureFlags } from 'core/userContext';
import { Action as BulkAction, BulkActionsBar } from 'ui/bulkActionsBar';
import { FullWidth } from 'ui/utility/fullWidth';
import { DatabaseRetain16 } from 'ui/icons/aurora/16px/DatabaseRetain16';
import { spacing } from 'ui/theme';
import { Tab, TabGroup } from 'ui/tabs';
import { pxToRem } from 'utils/convert';
import { CustomEventsDatePicker } from './CustomEventsDatePicker';
import { CustomEventsSearchInput } from './CustomEventsSearchInput';
import { useFiltersContext, useModalsContext, useSelectionContext } from '../contexts';
import { INGESTION_POLICIES } from '../types';

const FilterBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.double};
  min-width: ${pxToRem(880)};
  & > *:only-child {
    margin-left: auto;
  }
`;

const RightDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.half};
`;

export const SELECTABLE_INGESTION_POLICIES = omit(INGESTION_POLICIES, 'ALL');

export const CustomEventsFilterBar = () => {
  const { CustomEventsPageModernized } = useSelector(selectFeatureFlags);
  const {
    ingestionPolicyFilter,
    setIngestionPolicyFilter,
    searchQuery,
    setSearchQuery,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    preset,
    setPreset,
  } = useFiltersContext();
  const { showRetentionPeriodModal } = useModalsContext();
  const { selected } = useSelectionContext();

  const bulkActions: BulkAction[] = [
    {
      icon: <DatabaseRetain16 />,
      label: 'Edit retention policy',
      onClick: () => showRetentionPeriodModal(selected as string[]),
      sortIndex: 0,
    },
  ];

  return (
    <>
      {selected.length > 0 ? (
        <FullWidth>
          <BulkActionsBar actions={bulkActions} numSelected={selected.length} />
        </FullWidth>
      ) : (
        <FilterBar>
          {CustomEventsPageModernized && (
            <TabGroup>
              {Object.entries(SELECTABLE_INGESTION_POLICIES).map(([id, label]) => (
                <Tab
                  key={id}
                  id={id}
                  label={label}
                  isSelected={ingestionPolicyFilter === label}
                  onClick={() => setIngestionPolicyFilter(label)}
                />
              ))}
            </TabGroup>
          )}
          <RightDiv>
            <CustomEventsDatePicker
              start={startDate}
              end={endDate}
              preset={preset}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setPreset={setPreset}
            />
            <CustomEventsSearchInput searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </RightDiv>
        </FilterBar>
      )}
    </>
  );
};
